import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('pavishna_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authAPI = {
  login: (data) => API.post('/auth/login', data),
  register: (data) => API.post('/auth/register', data),
  me: () => API.get('/auth/me'),
};

export const jobsAPI = {
  getAll: (params) => API.get('/jobs', { params }),
  getById: (id) => API.get(`/jobs/${id}`),
  adminGetAll: () => API.get('/jobs/admin/all'),
  create: (data) => API.post('/jobs', data),
  update: (id, data) => API.put(`/jobs/${id}`, data),
  delete: (id) => API.delete(`/jobs/${id}`),
};

export const contactAPI = {
  send: (data) => API.post('/contact', data),
  getAll: () => API.get('/contact'),
  updateStatus: (id, status) => API.put(`/contact/${id}`, { status }),
};

export const applicationsAPI = {
  apply: (data) => API.post('/applications', data),
  getAll: () => API.get('/applications'),
  getStats: () => API.get('/applications/stats/overview'),
  updateStatus: (id, status) => API.put(`/applications/${id}`, { status }),
};

export default API;
